import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "booking-details"
}
const _hoisted_3 = { class: "booking-details--card" }
const _hoisted_4 = { class: "booking-details--card-car" }
const _hoisted_5 = { class: "booking-details--card-car-image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "booking-details--card-car-info" }
const _hoisted_8 = { class: "booking-details--card-car-info-class" }
const _hoisted_9 = {
  key: 0,
  class: "booking-details--card-car-price"
}
const _hoisted_10 = {
  key: 0,
  class: "booking-details--vehicle-reg-no"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_12 = { class: "form-label" }
const _hoisted_13 = { class: "form-control-value" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "booking-details--card-map" }
const _hoisted_17 = { class: "booking-details--card-address" }
const _hoisted_18 = { class: "form-group-horizontal" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Booking #", -1)
const _hoisted_20 = { class: "form-control-value" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Pick up address", -1)
const _hoisted_24 = { class: "form-control-value" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Dropoff address", -1)
const _hoisted_28 = { class: "form-control-value" }
const _hoisted_29 = { class: "booking-details--card booking-details--card-notes" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "booking-details--card-customer-wrap" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, " Customer ", -1)
const _hoisted_33 = { class: "booking-details--card-customer-phone" }
const _hoisted_34 = ["href"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, " Name on meeting sign ", -1)
const _hoisted_38 = { class: "form-control-value" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_40 = { class: "form-group-horizontal" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Flight number", -1)
const _hoisted_42 = { class: "form-control-value" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_44 = { class: "form-group-horizontal" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Date & time", -1)
const _hoisted_46 = { class: "form-control-value" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Special note", -1)
const _hoisted_50 = { class: "form-control-value font-weight-300" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Driver notes", -1)
const _hoisted_54 = { class: "form-control-value font-weight-300 booking-details--notes" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Download files", -1)
const _hoisted_58 = { class: "form-control-value font-weight-300" }
const _hoisted_59 = ["href"]
const _hoisted_60 = {
  key: 0,
  class: "btn-list"
}
const _hoisted_61 = ["href"]

import { computed, ref, onMounted, onUnmounted } from "vue";
import { useRoute } from 'vue-router'
import { useIntervalFn } from '@vueuse/core'
import { useUser } from "@/store/user";
import { useBooking } from "@/store/booking";
import { Booking } from "@/models/your-bookings";
import BookingPaymentStatusLabel from "@/components/BookingPaymentStatusLabel.vue";
import BookingTag from "@/components/BookingTag.vue";
import AccountInfoModal from "@/views/my-account/AccountInfoModal.vue";
import CancelBookingModal from "@/views/booking-details/CancelBookingModal.vue";
import GoogleMap from "@/views/booking-details/GoogleMap.vue";
import GoogleDirections from "@/views/booking-details/GoogleDirections.vue";
import DriverActionBtns from "@/views/booking-details/DriverActionBtns.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingsDetail',
  setup(__props) {

const route = useRoute()
const bookingIdParam = route.params.id as unknown as number

const { user, isDriver, isCustomer, isAdmin } = useUser()
const { getBooking } = useBooking(bookingIdParam)

const cancelModalVisible = ref(false)
const accountModalVisible = ref(false)
const booking = ref<Booking>()

const customerTelNo = computed(() => {
  let telNo = null;
  if (isDriver.value) {
    if (booking.value?.clientContact) {
      telNo = booking.value.clientContact;
    } else if (booking.value?.customer.mobile) {
      telNo = booking.value.customer.mobile;
    }
  }

  return telNo;
})

const callCustomerLink = computed(() => {
  if (customerTelNo.value) {
    return `tel:${customerTelNo.value}`;
  }

  return null
})

const onJobStatusUpdate = (b: Booking) => {
  booking.value = b
}

const fetchBooking = async () => {
  booking.value = await getBooking()
}

onMounted(fetchBooking)
const { pause } = useIntervalFn(fetchBooking, 5000)
onUnmounted(pause)

return (_ctx: any,_cache: any) => {
  const _component_UserPositionBar = _resolveComponent("UserPositionBar")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppHeaderProgressBar = _resolveComponent("AppHeaderProgressBar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UserPositionBar),
    _createVNode(_component_AppHeader, {
      title: "booking details",
      "back-route-to": { name: 'bookings', query: _unref(route).query }
    }, null, 8, ["back-route-to"]),
    _createVNode(_component_AppHeaderProgressBar),
    _createElementVNode("div", _hoisted_1, [
      (booking.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (booking.value.driverVehicle?.vehicle)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: booking.value.driverVehicle.vehicle.vehicleCat?.image
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(booking.value.driverVehicle?.vehicle?.vehicleCat?.name), 1),
                  (booking.value.paymentStatus)
                    ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                        key: 0,
                        status: booking.value.paymentStatus
                      }, null, 8, ["status"]))
                    : _createCommentVNode("", true),
                  (booking.value.isCancelled)
                    ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                        key: 1,
                        status: "cancelled"
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isDriver) && booking.value.hasDriverConfirmedJob)
                    ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                        key: 2,
                        status: "confirmed"
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.tags, (v, k) => {
                    return (_openBlock(), _createBlock(BookingTag, {
                      key: k,
                      tag: v
                    }, null, 8, ["tag"]))
                  }), 128))
                ]),
                (_unref(isCustomer) || _unref(isDriver))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(booking.value.priceFormatted), 1))
                  : _createCommentVNode("", true)
              ]),
              (_unref(isDriver))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.vehicles, (v, k) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "form-group-horizontal",
                        key: k
                      }, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(v.vehicle?.regNo), 1),
                        _createElementVNode("div", _hoisted_13, [
                          (v.driver?.id == _unref(user)?.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, " You"))
                            : (v.driver?.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(v.driver?.fullName), 1))
                              : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                (_unref(isDriver) || _unref(isAdmin))
                  ? (_openBlock(), _createBlock(GoogleDirections, {
                      key: 0,
                      booking: booking.value
                    }, null, 8, ["booking"]))
                  : (_openBlock(), _createBlock(GoogleMap, {
                      key: 1,
                      booking: booking.value
                    }, null, 8, ["booking"]))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(booking.value.id), 1)
                ]),
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(booking.value.pickup), 1)
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString(booking.value.destination), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(customerTelNo)), 1)
                  ]),
                  (_unref(callCustomerLink))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-primary btn-sm booking-details--card-customer-call-btn",
                        href: _unref(callCustomerLink)
                      }, " Call ", 8, _hoisted_34))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, _toDisplayString(booking.value.clientRef1), 1)
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, _toDisplayString(booking.value.flight), 1)
              ]),
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, _toDisplayString(booking.value.jobStartFormatted), 1)
              ]),
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, _toDisplayString(booking.value.pickupInstructions), 1)
              ]),
              (_unref(isDriver))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, _toDisplayString(booking.value.driverNotes), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              ((_unref(isDriver) || _unref(isAdmin)) && booking.value.driverFiles?.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_55,
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.driverFiles, (v) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: v.id
                            }, [
                              _createElementVNode("a", {
                                class: "booking-details--booking-file",
                                target: "_blank",
                                href: v.downloadUrl
                              }, _toDisplayString(v.title ? v.title :
                      v.clientFileName) + " (" + _toDisplayString(v.clientFileName) + ")", 9, _hoisted_59)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (_unref(isDriver) || _unref(isAdmin))
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  (booking.value.meetgreetUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-block btn-secondary",
                        href: booking.value.meetgreetUrl,
                        target: "_blank"
                      }, " Meet & Greet ", 8, _hoisted_61))
                    : _createCommentVNode("", true),
                  (_unref(isDriver))
                    ? (_openBlock(), _createBlock(DriverActionBtns, {
                        key: 1,
                        booking: booking.value,
                        "onUpdate:status": onJobStatusUpdate
                      }, null, 8, ["booking"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(isCustomer))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (booking.value.canCustomerCancelBooking)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-block btn-cancel booking-details--btn-cancel",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (cancelModalVisible.value = true), ["prevent"]))
                      }, " Cancel booking "))
                    : _createCommentVNode("", true),
                  (booking.value.isVehicleLocationViewable)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: {
            name: 'booking_vehicle_location',
            params: { id: booking.value.id },
          },
                        class: "btn btn-block btn-secondary booking-details--btn-confirm-job"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Check vehicle location")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(CancelBookingModal, {
              show: cancelModalVisible.value,
              booking: booking.value,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (cancelModalVisible.value = false)),
              onCancelled: fetchBooking
            }, null, 8, ["show", "booking"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(AccountInfoModal, {
      show: accountModalVisible.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (accountModalVisible.value = false))
    }, null, 8, ["show"])
  ]))
}
}

})